var React = require('react');

function Desktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1 1.5C1 1.22386 1.22386 1 1.5 1H14.5C14.7761 1 15 1.22386 15 1.5V9H1V1.5ZM0 9.5V1.5C0 0.671573 0.671573 0 1.5 0H14.5C15.3284 0 16 0.671573 16 1.5V9.5V11.5C16 12.3284 15.3284 13 14.5 13H10V15H12.5C12.7761 15 13 15.2239 13 15.5C13 15.7761 12.7761 16 12.5 16H9.5H6.5H3.5C3.22386 16 3 15.7761 3 15.5C3 15.2239 3.22386 15 3.5 15H6V13H1.5C0.671573 13 0 12.3284 0 11.5V9.5ZM6.5 12H1.5C1.22386 12 1 11.7761 1 11.5V10H15V11.5C15 11.7761 14.7761 12 14.5 12H9.5H6.5ZM7 13V15H9V13H7Z"}));
}

Desktop.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Desktop;

Desktop.default = Desktop;
